import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import autosize from 'autosize';
import smoothscroll from 'smoothscroll-polyfill';
import form from '@/library/form';
import menu from '@/library/menu';
import popup from '@/library/popup';
import stripe from '@/library/stripe';

smoothscroll.polyfill();

(function (window, document, undefined) {
    'use strict';

    let RR = function () {
        this.sections = document.querySelectorAll(this.config.selectorSection);
        this.init();
    };

    RR.prototype = {
        config: {
            classBackground: 'rr-background',
            classClose: 'rr-close',
            classIsActive: 'is-active',
            classIsClosing: 'is-closing',
            classIsFinished: 'is-finished',
            classIsLoaded: 'is-loaded',
            classIsLoading: 'is-loading',
            classIsOpen: 'is-open',
            classIsOpening: 'is-opening',
            classIsVisible: 'is-visible',
            keys: {
                ESC: 27,
            },
            regexPhone: /(mobi|ipod|phone|blackberry|opera mini|fennec|minimo|symbian|psp|nintendo ds|archos|skyfire|puffin|blazer|bolt|gobrowser|iris|maemo|semc|teashark|uzard)/,
            regexTablet: /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/,
            selectorContent: '.rr-content',
            selectorInner: '.rr-inner',
            selectorPage: '.rr-page',
            selectorSection: '.rr-section:not(.rr-info)',
            selectorViewPage: '.rr-view-page',
        },

        ajax: function (method, url, data, success, error) {
            let xhr = new XMLHttpRequest();
            xhr.open(method, url);
            xhr.setRequestHeader("Accept", "application/json");
            xhr.onreadystatechange = () => {
                if (xhr.readyState !== XMLHttpRequest.DONE) return;
                if (xhr.status === 200) {
                    success(xhr.response, xhr.responseType);
                } else {
                    error(xhr.status, xhr.response, xhr.responseType);
                }
            };
            xhr.send(data);
        },

        closeDesktop (section) {
            const rect = section.getBoundingClientRect();
            anime({
                targets: [section.querySelector(this.config.selectorInner)],
                duration: 500,
                easing: 'easeInOutSine',
                translateX: 0,
                width: rect.width,
                complete: this.onCloseComplete.bind(this, section),
            });
        },

        closeMobile (section) {
            let content = section.querySelector(this.config.selectorContent);
            enableBodyScroll(content);
            anime({
                targets: [content],
                duration: 500,
                easing: 'easeInOutSine',
                translateX: 0,
                complete: this.onCloseComplete.bind(this, section),
            });
        },

        deviceClass: function () {
            let ua = navigator.userAgent.toLowerCase();
            if (this.config.regexTablet.test(ua)) {
                return 'tablet';
            }
            if (this.config.regexPhone.test(ua)) {
                return 'phone';
            }
            return 'desktop';
        },

        forEach (array, callback, scope) {
            for (let i = 0; i < array.length; i++) {
                callback.call(scope, i, array[i]);
            }
        },

        formError: function (form, status, response, responseType) {
            let msg = 'There was an error and your message could not be sent. Please reload the page and try again.';
            let success = false;
            this.setFormStatus(form, success, msg);
        },

        formSuccess: function (form, response, responseType) {
            form.reset();
            this.forEach(form.querySelectorAll('select'), (index, selectEl) => {
                this.onSelectChange(selectEl);
            });
            let msg = 'Thank you for your message! If appropriate, we will respond shortly.';
            let success = true;
            this.setFormStatus(form, success, msg);
        },

        init: function () {
            let device = this.deviceClass();
            this.isPhone = device === 'phone';
            document.body.classList.add(device);
            this.initEvents();
            this.initForm();
            this.initLoader();
        },

        initEvents: function () {
            this.forEach(this.sections, (index, sectionEl) => {
                let el = sectionEl;
                if (this.isPhone) {
                    el = sectionEl.querySelector(this.config.selectorViewPage);
                }
                el.addEventListener('click', this.onOpen.bind(this, sectionEl));
            });
            document.addEventListener('keydown', this.onKeydown.bind(this));
        },

        initForm: function () {
            this.forEach(document.querySelectorAll('.float-label select'), (index, selectEl) => {
                selectEl.addEventListener('change', (ev) => {
                    this.onSelectChange(ev.target);
                })
                this.onSelectChange(selectEl);
            });
            this.forEach(document.querySelectorAll('form.formspree'), (index, formEl) => {
                formEl.addEventListener('submit', this.onSubmitForm.bind(this));
            });
            autosize(document.querySelectorAll('textarea'));
        },

        initLoader: function () {
            imagesLoaded(document.body, {background: '.'+this.config.classBackground},
                () => document.body.classList.remove(this.config.classIsLoading)
            );
        },

        insertClose: function (section) {
            let close = document.createElement('div');
            close.classList.add(this.config.classClose);
            section.querySelector(this.config.selectorPage).appendChild(close);
            close.addEventListener('click', this.onClose.bind(this, section));
        },

        onClose: function (section, ev) {
            if (this.isAnimating) return;
            this.isAnimating = true;
            document.body.classList.add(this.config.classIsClosing);
            section.classList.add(this.config.classIsClosing);
            this[this.isPhone ? 'closeMobile' : 'closeDesktop'](section);
        },

        onCloseComplete: function (section) {
            this.removeClose(section);
            document.body.classList.remove(this.config.classIsClosing);
            document.body.classList.remove(this.config.classIsOpen);
            section.classList.remove(this.config.classIsActive);
            section.classList.remove(this.config.classIsClosing);
            section.classList.remove(this.config.classIsLoaded);
            this.isAnimating = false;
            this.isOpen = false;
        },

        onKeydown: function (ev) {
            if (this.config.keys.ESC !== ev.which) return;
            if (this.isOpen) {
                let section = document.querySelector(this.config.selectorSection+'.'+this.config.classIsActive);
                if (section) {
                    this.onClose(section, ev);
                }
            }
            if (this.isMenuOpen) {
                this.toggleMenu();
            }
        },

        onOpen: function (section, ev) {
            if (this.isAnimating) return;
            this.isAnimating = true;
            document.body.classList.add(this.config.classIsOpening);
            section.classList.add(this.config.classIsActive);
            section.classList.add(this.config.classIsOpening);
            this.insertClose(section);
            this[this.isPhone ? 'openMobile' : 'openDesktop'](section);
        },

        onOpenComplete: function (section) {
            document.body.classList.remove(this.config.classIsOpening);
            document.body.classList.add(this.config.classIsOpen);
            section.classList.remove(this.config.classIsOpening);
            section.classList.add(this.config.classIsLoaded);
            this.isAnimating = false;
            this.isOpen = true;
        },

        onSelectChange: function (el) {
            el.classList[el.value === '' ? 'add' : 'remove']('is-empty');
        },

        onSubmitForm: function (ev) {
            ev.preventDefault();
            const form = ev.target;
            const data = new FormData(form);
            form.classList.remove(this.config.classIsFinished);
            this.formButton = form.querySelector('[type=submit]');
            if (this.formButton) {
                this.formButton.setAttribute('disabled', '');
            }
            this.ajax(form.method, form.action, data, this.formSuccess.bind(this, form), this.formError.bind(this, form));
        },

        openDesktop (section) {
            const rect = section.getBoundingClientRect();
            anime({
                targets: [section.querySelector(this.config.selectorInner)],
                duration: 500,
                easing: 'easeInOutSine',
                translateX: -rect.left,
                width: window.innerWidth,
                complete: this.onOpenComplete.bind(this, section),
            });
        },

        openMobile (section) {
            const rect = section.getBoundingClientRect();
            window.scrollBy({
                top: rect.top,
                behavior: 'smooth'
            });
            let content = section.querySelector(this.config.selectorContent);
            disableBodyScroll(content);
            anime({
                targets: [content],
                duration: 500,
                easing: 'easeInOutSine',
                translateX: '-100%',
                complete: this.onOpenComplete.bind(this, section),
            });
        },

        removeClose: function (section) {
            let close = section.querySelector('.'+this.config.classClose);
            if (close) {
                close.remove();
            }
        },

        setFormStatus: function (formEl, success, msg) {
            if (this.formButton) {
                this.formButton.removeAttribute('disabled');
            }
            const statusEl = formEl.querySelector('#form-status');
            if (statusEl) {
                const div = document.createElement('div');
                const color = success ? 'green' : 'red';
                div.innerHTML = msg;
                div.className = 'bg-' + color + '-100 text-' + color + '-500 p-3';
                statusEl.innerHTML = div.outerHTML;
            }
            formEl.classList.add(this.config.classIsFinished);
        },
    };

    window.RR = RR;

})(window, document);

window.APP = {
    form: form,
    menu: menu,
    popup: popup,
    stripe: stripe,
};

document.addEventListener('DOMContentLoaded', () => {
    let rapidresponse = new RR();
});
